import React from 'react'
import RightSide from '../components/common/rightSide';
import RefundPolicy from '../components/other/refundpolicy';


const RefundPolicyPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <RefundPolicy />
                    </div>

                </div>
            </div>
        </>
    )
}

export default RefundPolicyPage;